import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

import { DataLayerPageTypeEnum } from '@nocowanie/core/models';

import { MetaTags } from '@app/components/atoms/meta-tags';
import { PreviewBanner } from '@app/components/molecules/preview-banner';
import { Home } from '@app/components/pages/home';
import { DefaultTemplate } from '@app/components/templates/default-template';
import { usePageDataLayerEvents } from '@app/hooks/usePageDataLayerEvents';
import { PageProps } from '@app/models';
import { serverSidePropsHandler } from '@app/pages/index.server-side-props.handler';
import { nocowanieAppStateWrapper } from '@app/state/state';

const HomePage: NextPage<PageProps> = props => {
    nocowanieAppStateWrapper.useHydration(props);

    const { asPath: pagePath } = useRouter();
    usePageDataLayerEvents({
        pageType: DataLayerPageTypeEnum.Home,
        pagePath,
    });

    const { t } = useTranslation('home', {
        keyPrefix: 'metaTags',
    });

    return (
        <>
            <MetaTags description={t('description')} title={t('title')} titleSuffix={''} />
            <PreviewBanner isPreview={!!props.preview} />
            <DefaultTemplate showScrollTopButton={!!props.showScrollTopButton}>
                <Home />
            </DefaultTemplate>
        </>
    );
};

export const getServerSideProps = serverSidePropsHandler;

export default HomePage;
